// Header course menu data (shared by DropdownMenu and SiteHeader).

export const categoryMeta = {
  "Popular Live Course": { icon: "fa-fire", color: "#ff6b35" },
  "All Live Course": { icon: "fa-graduation-cap", color: "#7c3aed" },
  "Blogs": { icon: "fa-pencil-square-o", color: "#0ea5e9" },
  "Self Paced Course": { icon: "fa-play-circle", color: "#10b981" },
};

export const courseCategories = {
  "Popular Live Course": [
    {
      name: "LogicMojo GenAI & Agentic AI Course",
      description: "Master Generative AI, Agentic AI, LLMs and RAG with real-world industry projects.",
      image: "/react/ai-assets/images/data-transfer.jpg",
      link: "https://logicmojo.com/generative-ai-course/",
      badge: "Trending",
    },
    {
      name: "LogicMojo AI & ML Course",
      description: "Master cutting-edge AI skills in this industry-aligned Bootcamp.",
      image: "/react/ai-assets/images/data-science-icon.jpg",
      link: "https://logicmojo.com/artificial-intelligence-course/",
      badge: "Trending",
    },
    {
      name: "Data Science Course",
      description: "Master cutting-edge data science skills in this industry-aligned projects.",
      image: "/assets/dist/new_pages/images/ai_course_og_image.JPG",
      link: "https://logicmojo.com/datascience-course/",
      badge: "Trending",
    }
  ],
  "All Live Course": [
    {
      name: "LogicMojo GenAI & Agentic AI Course",
      description: "Master Generative AI, Agentic AI, LLMs and RAG with real-world industry projects.",
      image: "/react/ai-assets/images/data-transfer.jpg",
      link: "https://logicmojo.com/generative-ai-course/",
      badge: "New",
    },
    {
      name: "LogicMojo AI & ML Course",
      description: "Master AI, Machine Learning, and Generative AI with mentorship and real-world projects.",
      image: "/assets/dist/new_pages/images/ai_course_og_image.JPG",
      link: "https://logicmojo.com/artificial-intelligence-course/",
      badge: "New",
    },
    {
      name: "Data Science Course",
      description: "Master cutting-edge Data Science skills in this industry-aligned Bootcamp.",
      image: "/react/ai-assets/images/data-science-icon.jpg",
      link: "https://logicmojo.com/datascience-course/",
    },
  ],

  "Blogs": [
    {
      name: "Best AI Courses For Beginners",
      description: "Listing Best AI Courses for Beginners",
      image: "/react/ai-assets/images/data-structure-icon.jpg",
      link: "https://logicmojo.com/best-ai-courses-for-beginners",
    },
    {
      name: "Best Data Science Courses 2026",
      description: "Listing Best Data Science Courses in India",
      image: "/react/ai-assets/images/org-data.jpg",
      link: "https://logicmojo.com/best-data-science-courses",
    },
    {
      name: "Best DSA Courses",
      description: "Learn DSA From top 10 DSA Course",
      image: "/react/ai-assets/images/data-structure-icon.jpg",
      link: "https://logicmojo.com/best-dsa-course",
    },
    {
      name: "Best AI Courses 2026",
      description: "Check Best AI Courses in 2026",
      image: "/react/ai-assets/images/data-science-icon.jpg",
      link: "https://logicmojo.com/best-ai-courses",
    },
    {
      name: "Best Generative AI Courses",
      description: "Listing Best GenAI Courses",
      image: "/react/ai-assets/images/data-transfer.jpg",
      link: "https://logicmojo.com/best-generative-ai-courses/",
    },
    {
      name: "Best System Design Courses",
      description: "View Best System Design Courses",
      image: "/react/ai-assets/images/data-transfer.jpg",
      link: "https://logicmojo.com/best-system-design-courses/",
    },
    {
      name: "Best AI Courses in Bangalore 2026",
      description: "List Best AI Courses in Bangalore",
      image: "/react/ai-assets/images/org-data.jpg",
      link: "https://logicmojo.com/best-ai-courses-in-bangalore",
    },
    {
      name: "Best AI Course in Bangalore",
      description: "Logicmojo Best AI Course in Bangalore",
      image: "/react/ai-assets/images/data-science-icon.jpg",
      link: "https://logicmojo.com/ai-courses-in-bangalore",
    },
    {
      name: "Best AI courses for Working Professionals",
      description: "Listing Best AI Course For working Professionals",
      image: "/react/ai-assets/images/data-structure-icon.jpg",
      link: "https://logicmojo.com/best-ai-courses-for-working-professionals",
    },
  ],

  "Self Paced Course": [
    {
      name: "Cracking Coding & System Design",
      description: "Self Paced Video lecture Crash Course",
      image: "/react/ai-assets/images/video-presentation.jpg",
      link: "https://www.logicmojo.com/cracking_interview",
    },
    {
      name: "Cracking Coding Interview",
      description: "Self Paced Video lecture DSA Crash Course",
      image: "/react/ai-assets/images/video-lesson.jpg",
      link: "https://logicmojo.com/java-freshers-course",
    },
  ],
};

